import type { IsActiveMatchOptions } from "@angular/router";

export const EXACT_LINK_ACTIVE_OPTIONS: IsActiveMatchOptions = {
  paths: "exact",
  queryParams: "ignored",
  fragment: "ignored",
  matrixParams: "ignored",
};

export const SETTINGS_LINK_ACTIVE_OPTIONS: IsActiveMatchOptions = {
  paths: "subset",
  queryParams: "ignored",
  fragment: "ignored",
  matrixParams: "ignored",
};
